import calls from '@/backend/api-calls'

const state = () => ({
  assemblySheets: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  }
})

// getters
const getters = {
  ids: state => {
    return state.assemblySheets.map(d => d.id);
  }
}

// actions
const actions = {
  getAssemblySheets: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.cutsheetAssembly.get(parameters)
        .then(resp => {
          commit("setAssemblySheets", resp.data.results);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addAssemblySheet: ({commit}, {data, parameters}) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssembly.post(data, parameters)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Assembly sheet successfully created'
            },
            { root: true }
          );
          commit("insertAssemblySheet", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateAssemblySheet: ({commit}, {assemblySheetId, data}) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssembly.put(assemblySheetId, data)
        .then(resp => {
          commit("insertUpdatedAssemblySheet", resp.data);
          commit(
            'app/setNotification', { 
              status: true, 
              type: 'success',
              message: 'Assembly sheet successfully updated'
            }, { root: true }
          );
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteAssemblySheet: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssembly.delete(id)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Assembly sheet successfully deleted'
            },
            { root: true }
          );
          commit("removeAssemblySheet", id);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addAttachment: ({commit}, { assemblySheetId, attachment }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssembly.attach(assemblySheetId, attachment)
        .then(resp => {
          commit("insertUpdatedAssemblySheet", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addParts: ({commit}, { assemblySheetId, data }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssembly.put(assemblySheetId, data)
        .then(resp => {
          commit("updateAssemblySheet", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addPart: ({commit}, { assemblySheetId, data }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssemblyDetails.post(data, {
        assemblysheet_id: assemblySheetId
      }).then(resp => {
          commit(
            'app/setNotification', { 
              status: true, 
              type: 'success',
              message: 'Assembly sheet part successfully added'
            }, { root: true }
          );
          commit("insertPart", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updatePart: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssemblyDetails.put(detail.id, detail)
        .then(resp => {
          commit("insertUpdatedPart", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deletePart: ({commit}, { assemblySheetId, detailId }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetAssemblyDetails.delete(detailId)
        .then(resp => {
          commit(
            'app/setNotification', { 
              status: true, 
              type: 'success',
              message: 'Assembly sheet part successfully deleted'
            }, { root: true }
          );
          commit("removePart", { 
            assemblySheetId: assemblySheetId, detailId: detailId 
          });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  changePage(state, page) {
    state.pagination.page = page;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setAssemblySheets (state, data) {
    state.assemblySheets = data;
  },
  insertAssemblySheet (state, data) {
    state.assemblySheets.push(data);
  },
  removeAssemblySheet (state, id) {
    let ids = state.assemblySheets.map(d => d.id);
    let index = ids.indexOf(id);
    state.assemblySheets.splice(index, 1);
  },
  insertUpdatedAssemblySheet (state, data) {
    state.assemblySheets.forEach((assemblySheet, i) => {
      if (assemblySheet.id == data.id) {
        state.assemblySheets.splice(i, 1, data);
      }
    })
  },
  insertPart(state, data) {
    state.assemblySheets.forEach(assemblySheet => {
      if (assemblySheet.id == data.assemblysheet_id) {
        assemblySheet.details.push(data);
      }
    })
  },
  insertUpdatedPart (state, data) {
    state.assemblySheets.forEach(assemblySheet => {
      if (assemblySheet.id == data.assemblysheet_id) {
        assemblySheet.details.forEach((detail, i) => {
          if (detail.id == data.id) {
            assemblySheet.details.splice(i, 1, data);
          }
        })
      }
    })
  },
  removePart: (state, { assemblySheetId, detailId }) => {
    state.assemblySheets.forEach(assemblySheet => {
      if (assemblySheet.id == assemblySheetId) {
        assemblySheet.details.forEach((detail, i) => {
          if (detail.id == detailId) {
            assemblySheet.details.splice(i, 1);
          }
        })
      }
    })
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}